
















































































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import AudienceAvailabilitySelector from '@ui/AudienceSetWizard/components/AudienceAvailabilitySelector'
import MediaSelector from '@ui/MediaSelector'

settings =
  name: 'ItemDistributionFormStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      StepContainer,
      AudienceAvailabilitySelector,
      MediaSelector,
    }

    data: ->
      form: null
      selectedAvailabilityKeys: []
      mediaModal:
        show: false

    computed:
      actionsForMediaSelector: ->
        onUpload: @onUploadMedia
        onDone: @selectMedia

    mounted: ->
      @initializeData()
      @initializeSelectedAvailabilityKeys()

    methods:
      hiOpenMediaSelector: ->
        @mediaModal.show = true

      hiSetDefaultImage: (url) ->
        @form.default_image = url
        @rerender()

      selectMedia: (selectedKeys) ->
        @form.images = [...selectedKeys]

      onUploadMedia: (file) ->
        @wizard.fetch 'supplier_media_kit'

      initializeData: ->
        if @wizard.selectedItemDistribution
          @form = @wizard.selectedItemDistribution
          return

        @form = @wizard.prototypeForItemDistribution()
        @wizard.audienceSetData.spaces[@form.key] = @form

      initializeSelectedAvailabilityKeys: ->
        @selectedAvailabilityKeys = @wizard.audienceAvailabilitiesForSpace(@form.key).map((item) => item.key)

      addSpaceKeyToAudienceAvailability: (audienceAvailability) ->
        audienceAvailability.space_keys.push @form.key if @form.key not in audienceAvailability.space_keys

      removeSpaceKeyToAudienceAvailability: (audienceAvailability) ->
        audienceAvailability.space_keys = audienceAvailability.space_keys.filter((key) => key isnt @form.key)

    watch:
      selectedAvailabilityKeys: (selectedKeys) ->
        for audienceAvailability in @wizard.audienceSetData.audience_availabilities
          if audienceAvailability.key in selectedKeys
            @addSpaceKeyToAudienceAvailability audienceAvailability
          else
            @removeSpaceKeyToAudienceAvailability audienceAvailability

export default VueOptions.vue settings
